module.exports = __webpack_public_path__ + "static/media/onde-comprar-mail.93b48df7.svg";